import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid grid-nogutter col-12 md:col-8 md:col-offset-2 lg:col-4 lg:col-offset-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "col-12 center" }, "Settings", -1)
const _hoisted_3 = { class: "formgrid grid grid-nogutter col-12 pt-4 container-box" }
const _hoisted_4 = { class: "field col-9 p-2" }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "field col-3 p-2" }

import { onMounted, reactive, ref } from "vue"
import useVuelidate from "@vuelidate/core"
import { email, required } from "@vuelidate/validators"
import firebaseApp from "@/utilities/firebase/firebase"
import { getAuth, onAuthStateChanged, sendPasswordResetEmail } from "firebase/auth"
import { useToast } from "primevue/usetoast"

/* Lifecycle */

export default /*#__PURE__*/_defineComponent({
  __name: 'Settings',
  setup(__props) {

onMounted(async () => {
	const auth = getAuth(firebaseApp)

	onAuthStateChanged(auth, (user) => {

		// User is signed in
		if (user) {
			profileForm.email = user.email ?? ""
			isLoggedIn.value = true
		} else {
			profileForm.email = ""
			isLoggedIn.value = false
		}

	})

})

/* ------------------- Properties ----------------- */
const auth = getAuth(firebaseApp)
const toast = useToast()
const isLoggedIn = ref(false)


/* ------------------- Validation ----------------- */
const profileForm = reactive({
	email: "",
})
const rules = {
	email: { required, email },
}
const validation = useVuelidate(rules, profileForm)
const hasBeenSubmitted = ref(false)

/* ------------------- Methods ----------------- */

function resetPassword() {
	hasBeenSubmitted.value = true
	validation.value.$validate()

	if (validation.value.$error) {
		return
	}

	sendPasswordResetEmail(auth, profileForm.email)
		.then(() => {
			return toast.add({ severity: "success", summary: "Email sent", detail: `A password reset confirmation email has been sent to ${profileForm.email}`, life: 5000 })
		})
		.catch((error) => {
			if (error.code == "auth/user-not-found") {
				return toast.add({ severity: "error", summary: "User doesn't exist", detail: "The email is not registered within our platform", life: 5000 })
			}

			return toast.add({ severity: "error", summary: error.code, detail: error.message, life: 5000 })
		})
}


return (_ctx: any,_cache: any) => {
  const _component_p_input_text = _resolveComponent("p-input-text")!
  const _component_p_button = _resolveComponent("p-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_p_input_text, {
            id: "email",
            modelValue: _unref(validation).email.$model,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(validation).email.$model) = $event)),
            type: "email",
            autofocus: "",
            disabled: isLoggedIn.value,
            class: _normalizeClass([{ 'p-invalid': _unref(validation).email.$invalid && hasBeenSubmitted.value }, "w-full"])
          }, null, 8, ["modelValue", "disabled", "class"]),
          _createElementVNode("label", {
            for: "email",
            class: _normalizeClass({ 'p-error': _unref(validation).email.$invalid && hasBeenSubmitted.value })
          }, "Your email:", 2)
        ]),
        ((_unref(validation).email.$invalid) && hasBeenSubmitted.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(validation).email.$errors, (error) => {
                return (_openBlock(), _createElementBlock("small", {
                  key: error.$uid,
                  class: "p-error"
                }, _toDisplayString(error.$message), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_p_button, {
          onClick: resetPassword,
          label: "Reset password",
          class: "p-button-danger w-full center"
        })
      ])
    ])
  ]))
}
}

})